/**
 * @file Azure B2C authentication configuration
 * @module config/auth
 */

/**
 * MSAL configuration object.
 * Pulled from environment variables.
 * @type {import('@azure/msal-browser').Configuration}
 */
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_B2C_CLIENT_ID,
    authority: import.meta.env.VITE_AZURE_B2C_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AZURE_B2C_KNOWN_AUTHORITIES],
    redirectUri: import.meta.env.VITE_AZURE_B2C_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_B2C_REDIRECT_URI,
    navigateToLoginRequestUrl: false, // Set to false for popup flow
  },
  cache: {
    cacheLocation: "localStorage", // This enables persistent caching
    storeAuthStateInCookie: true // Recommended for IE/Edge
  }
};

/**
 * Defines the scopes needed for login requests.
 * Scopes are read from environment variables and split into an array.
 * @type {{scopes: Array<string>}}
 */
export const loginRequest = {
  scopes: import.meta.env.VITE_AZURE_B2C_SCOPES.split(' ')
};

/**
 * Defines protected API resources and their required scopes for token acquisition.
 * Endpoint and scopes are read from environment variables.
 * @type {{api: {endpoint: string, scopes: Array<string>}}}
 */
export const protectedResources = {
  api: {
    endpoint: import.meta.env.VITE_API_URL,
    scopes: import.meta.env.VITE_AZURE_B2C_SCOPES.split(' ')
  }
};

/**
 * Combined authentication configuration object containing MSAL config,
 * login request parameters, and protected resource definitions.
 */
const authConfig = {
  msalConfig,
  loginRequest,
  protectedResources
};

export default authConfig;
